import dateFormat from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { MUTATION_GROUP } from './constants.tsx';
import type { JiraDateTimeFieldInput } from './types.tsx';

export const mutateDateTimeField = (date: string, fieldId: string): JiraDateTimeFieldInput => {
	const dateTimeInputFormat = "yyyy-MM-dd'T'HH:mm:ssXXX";
	return {
		fieldId,
		dateTime: { formattedDateTime: dateFormat(parseISO(date), dateTimeInputFormat) },
		mutationGroup: MUTATION_GROUP,
	};
};
